import { connect, Dispatch } from 'react-redux';
import { UsersPage, UsersGridProps, UsersGridActionProps } from './component';
import { AppState } from '../app/state';
import { ListRowsAction } from 'components/user-grid/actions';
import { Action } from 'helpers/action-helpers';
import { GetTenantAction } from 'pages/settings/actions';

const mapStateToProps = ({ login, userManagement }: AppState): UsersGridProps => {
  return {
    permissions: login.permissions,
    isLoading: userManagement.isLoadingUsersList
  };
};

function mapDispatchToProps(dispatch: Dispatch<Action>): UsersGridActionProps {
  return {
    getTenant: () => dispatch(new GetTenantAction()),
    listUsers: () => dispatch(new ListRowsAction())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);


// WEBPACK FOOTER //
// ./src/pages/users/index.ts